<template>
  <div class="seniorclass-container">
    <div class="seniorclass-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/about', query: { cid: fid } }">关于金色年华</BreadcrumbItem>
        <BreadcrumbItem to="/seniorclass">长者课堂</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="seniorclass-list">
          <div class="seniorclass-list_">
            <router-link class="seniorclass-li" v-for="item in list" :key="item.id" :to="{ path: '/seniorclass/detail', query: { cid: item.classid, id: item.id, page: page } }">
              <div class="seniorclass-li-img" v-if="item.picurl"><div :style="'backgroundImage:url(' + domainNameH5 + '/' + item.picurl + ')'"></div></div>
              <div class="seniorclass-li-info">
                <div class="seniorclass-li-head">
                  <div class="seniorclass-li-title">{{item.title}}</div>
                  <div class="seniorclass-li-date">{{item.posttime}}</div>
                </div>
                <div class="seniorclass-li-desc">{{item.description}}</div>
              </div>
            </router-link>
          </div>
          <div class="list-page clear" v-if="totalsPage>1">
            <Page
              :current="page"
              :total="totals"
              @on-change="changePage"
              :page-size="6"
              prev-text="上一页"
              next-text="下一页"
            />
            <div class="list-page-total">共{{totalsPage}}页</div>
            <div class="list-page-jump">
              到第 <Input v-model="jumpPage" /> 页
            </div>
            <div class="list-page-btn" @click="jumpPageDeal">确定</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">关于金色年华</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id">
              <router-link :to="{ path: '/about', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/publicwelfare" class="left-nav-link">
                <div class="chname">{{publicwelfarename.classname}}</div>
                <div class="enname">{{publicwelfarename.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/seniorclass" class="left-nav-link">
                <div class="chname">{{seniorclassname.classname}}</div>
                <div class="enname">{{seniorclassname.classname_en}}</div>
                <span></span>
              </router-link>
              <div class="left-subnav">
                <div class="left-subnav-li" v-for="item in lesson" :key="item.id" :class="[ item.id == cid ? 'active' : '']">
                  <router-link :to="{ path: '/seniorclass', query: { cid: item.id } }" class="left-subnav-link">{{item.classname}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateInteger } from '../../assets/js/validate.js'
import { getHeaderData, getSeniorClassBasicData, getSeniorClassListData } from '../../api/getData.js'
export default {
  name: 'seniorClass',
  data () {
    return {
      headerInfo: {},
      fid: '',
      cid: '',
      page: 1,
      jumpPage: '',
      totals: 0,
      totalsPage: 1,
      currentClassName: '',
      fname: {},
      publicwelfarename: {},
      seniorclassname: {},
      getsort: [],
      lesson: [],
      list: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.page = this.$route.query.page === undefined ? 1 : parseFloat(this.$route.query.page)
      this.getHeaderInfo()
      this.getSeniorClassListInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.page = this.$route.query.page === undefined ? 1 : parseFloat(this.$route.query.page)
    this.getSeniorClassBasicInfo(this.cid)
    this.getSeniorClassListInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'about', activeSendMenu: 'seniorclass' }).then(() => {}).catch(() => {})
    },
    async getSeniorClassBasicInfo (cid) {
      let postData = {}
      if (cid !== '') {
        postData.cid = cid
      }
      let result = await getSeniorClassBasicData(postData)
      this.fid = result.fid
      this.cid = result.cid
      this.fname = result.fname
      this.publicwelfarename = result.publicwelfarename
      this.seniorclassname = result.seniorclassname
      this.getsort = result.aboutus
      this.lesson = result.lesson
      this.getHeaderInfo()
    },
    async getSeniorClassListInfo () {
      let postData = {}
      if (this.cid !== '') {
        postData.cid = this.cid
      }
      postData.p = this.page
      let result = await getSeniorClassListData(postData)
      this.totals = result.totalnum
      this.totalsPage = Math.ceil(result.totalnum / 6)
      this.currentClassName = result.cname
      this.list = result.list
    },
    changePage (page) {
      this.page = page
      this.getSeniorClassListInfo()
    },
    jumpPageDeal () {
      if (!validateInteger(this.jumpPage)) {
        this.message('请输入正整数')
        return false
      }
      if (this.jumpPage > this.totalsPage) {
        this.message('页码不能大于' + this.totalsPage)
        return false
      }
      this.page = parseFloat(this.jumpPage)
      this.getSeniorClassListInfo()
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding-bottom: 230px;
  }
  .seniorclass-list {
    width: 77.22%;
    padding: 0 0 0 35px;
    .seniorclass-list_{
      padding: 35px 48px 38px;
      background-color: #ffffff;
    }
    .seniorclass-li{
      display: block;
      margin-bottom: 30px;
      padding: 14px 19px;
      border: 1px solid #d2d2d2;
      overflow: hidden;
      .seniorclass-li-img{
        position: relative;
        float: left;
        width: 200px;
        height: 160px;
        margin-right: 28px;
        overflow: hidden;
        div{
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background-image: url("../../assets/images/seniorclass.jpg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      .seniorclass-li-info{
        overflow: hidden;
        .seniorclass-li-head{
          overflow: hidden;
          .seniorclass-li-title{
            float: left;
            font-size: 24px;
            line-height: 42px;
            color: #ec6420;
            font-weight: bold;
          }
          .seniorclass-li-date{
            float: right;
            font-size: 18px;
            line-height: 42px;
            color: #4b7bbe;
          }
        }
        .seniorclass-li-desc{
          margin-top: 9px;
          font-size: 18px;
          line-height: 30px;
          color: #333333;
        }
      }
    }
  }
  @media screen and (max-width: 1580px){
    .inside-main{
      padding-bottom: 195px;
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding-bottom: 80px;
    }
    .seniorclass-list {
      width: 100%;
      padding: 0;
      .seniorclass-list_{
        padding: 15px;
      }
      .seniorclass-li{
        margin-bottom: 15px;
        padding: 7px 9px;
        border: 1px solid #d2d2d2;
        overflow: hidden;
        .seniorclass-li-img{
          float: none;
          width: 100%;
          height: 0;
          padding-top: 80%;
          margin-right: 14px;
        }
        .seniorclass-li-info{
          padding: 15px 0;
          .seniorclass-li-head{
            overflow: hidden;
            .seniorclass-li-title{
              float: none;
              font-size: 14px;
              line-height: 21px;
            }
            .seniorclass-li-date{
              float: none;
              font-size: 12px;
              line-height: 21px;
            }
          }
          .seniorclass-li-desc{
            margin-top: 9px;
            font-size: 12px;
            line-height: 15px;
          }
        }
      }
    }
  }
</style>
